export { default } from "bullitttime-embermodelsevent/adapters/jury-member";
